module.exports = __webpack_public_path__ + "img/text-header.3d9a353d.png";